import React from 'react';
import { CouponScopeEnum } from '../../../../api/payments/coupons/domain/enum';
import { CouponScopeLabels } from '../../../../api/payments/coupons/domain/labels';
import { JdsTag } from '../../../../components/jds/JdsTag';
import { formatCycleRange, formatRuleValue } from '../utils';

export const getRuleCardId = (rule) => `coupon-rule-${rule._key}`;

// Resumo dos descontos do formulário: uma linha por regra, na ordem dos
// cards. Clicar numa linha rola até o card correspondente.
export function CouponRulesOverview({ rules, plans, extraPlansById, addons }) {
  const getTarget = (rule) => {
    if (rule.scope === CouponScopeEnum.PLAN) {
      const plan =
        plans.find((p) => p.id === rule.planId) ?? extraPlansById[rule.planId];
      return plan?.name ?? null;
    }
    if (
      rule.scope === CouponScopeEnum.ADDON_TOTAL ||
      rule.scope === CouponScopeEnum.ADDON_ITEM
    ) {
      return addons.find((a) => a.id === rule.addonId)?.name ?? null;
    }
    return '-';
  };

  const goToRule = (rule) =>
    document
      .getElementById(getRuleCardId(rule))
      ?.scrollIntoView({ behavior: 'smooth', block: 'center' });

  return (
    <div className="mt-6">
      <h3 className="jds-title-sm mb-3">
        Resumo dos descontos ({rules.length})
      </h3>
      <div style={{ overflowX: 'auto' }}>
        <table className="table jds-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Aplicável em</th>
              <th>Plano/Produto</th>
              <th>Desconto</th>
              <th>Ciclos</th>
            </tr>
          </thead>
          <tbody>
            {rules.map((rule, index) => {
              const target = getTarget(rule);
              const incomplete = target === null || rule.value === '';
              return (
                <tr
                  key={rule._key}
                  role="button"
                  tabIndex={0}
                  style={{ cursor: 'pointer' }}
                  onClick={() => goToRule(rule)}
                  onKeyDown={(e) => e.key === 'Enter' && goToRule(rule)}
                >
                  <td>{index + 1}</td>
                  <td>{CouponScopeLabels[rule.scope] ?? rule.scope}</td>
                  <td>
                    {target ?? (
                      <JdsTag color="warning" label="Não selecionado" />
                    )}
                  </td>
                  <td>
                    {formatRuleValue(rule)}
                    {incomplete && (
                      <>
                        {' '}
                        <JdsTag color="warning" label="Incompleto" />
                      </>
                    )}
                  </td>
                  <td>{formatCycleRange(rule.fromCycle, rule.toCycle)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
